import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from "@angular/common/http";
import { Observable, from } from "rxjs";
import { mergeMap } from "rxjs/operators";
import { AngularFireAuth } from "@angular/fire/auth";

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
  constructor(public afAuth: AngularFireAuth) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Exclude auth token for /api/user/xxx path
    const regex = new RegExp("api/user/([a-zA-Z]|[0-9])+$");
    if (regex.test(request.url)) {
      return next.handle(request);
    }

    return this.getUserToken().pipe(
      mergeMap((token) => {
        if (token) {
          // console.log('intecepr', token);
          request = request.clone({
            headers: request.headers.set("Authorization", "Bearer " + token),
          });
        }
        if (!request.headers.has("Content-Type")) {
          request = request.clone({
            headers: request.headers.set("Content-Type", "application/json"),
          });
        }
        request = request.clone({
          headers: request.headers.set("Accept", "application/json"),
        });
        return next.handle(request);
      })
    );
  }

  getUserToken() {
    return this.fromFirebaseAuthPromise(
      this.afAuth.auth.currentUser.getIdToken()
    );
  }

  private fromFirebaseAuthPromise(promise): Observable<any> {
    return from(promise as Promise<any>);
  }
}
